'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = exports.toggle = exports.hide = exports.show = undefined;

var _Scroll = require('./Scroll');

/**
 *  Dependency: <div class="overlay" data-overlay></div> in theme.liquid,
 *              components/_overlay.scss
 *
 *  Note: _overlay.scss hold the styles for the overlay container
 *  Note: .overlay has a z-index of 1000, so any modal that needs to appear on top
 *        of the overlay need to have an z-index of 1001+
 *
 *
 */

var dom = {
  overlay: '[data-overlay]',
  modal: '[data-modal]'
};

var show = exports.show = function show() {
  var lockScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  if (lockScroll) {
    (0, _Scroll.lock)();
  }
  return $(dom.overlay).fadeIn(300);
};

var hide = exports.hide = function hide(event) {
  if (event) {
    if (event.target.classList.contains('is-no-click')) {
      return;
    }
  }
  (0, _Scroll.unlock)();
  $(dom.modal).removeClass('is-active');
  $(dom.overlay).removeClass('is-no-click');
  $(dom.overlay).attr('class', 'overlay'); // Remove all modifier classes
  return $(dom.overlay).fadeOut(300);
};

var toggle = exports.toggle = function toggle() {
  return $(dom.overlay).fadeToggle(300);
};

var bindUIActions = function bindUIActions() {
  $(dom.overlay).on('click', hide);
};

var init = exports.init = function init() {
  bindUIActions();
  console.log('[BVA] Component Loaded: Overlay');
};